import React from "react";
import moment from "moment";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import useGenerateTableColumns from "./hooks/useGenerateTableColumns";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import { addCommasWithoutEffectingDecimals } from "@domains/utils/numberMethods";
var generateTableColumns = function (_a) {
    var id = _a.id, subCategoryId = _a.subCategoryId, checked = _a.checked, handleCheck = _a.handleCheck, handleSelectAll = _a.handleSelectAll, data = _a.data;
    //
    var defaultSchemeRenderer = function (keys) {
        return (React.createElement("div", { className: "d-flex align-item-center gap-14" },
            React.createElement("div", { className: "ob-scheme-name-tooltip align-items-center tooitip-wrapper" },
                React.createElement(GenericSchemeName, { name: keys[0], subText1: subCategoryId === Number(ESubProductIds.AIF)
                        ? String(keys[1])
                        : String(keys[3]), showImage: true, subText2: subCategoryId === Number(ESubProductIds.AIF)
                        ? String(keys[2])
                        : "", maxWidth: 240, maxWidthUnit: "px", showTooltip: false, parentClassName: "text-start", tooltipPlacement: "auto-start" }))));
    };
    var generateDate = function (displayData) {
        var date = moment(displayData);
        var formattedDate = date.format("DD MMM YY");
        var formattedTime = date.format("hh:mm:ss A");
        return displayData ? (React.createElement("div", { className: "d-flex flex-column gap-1 text-end txt-grey-shade1" },
            React.createElement("span", { className: "txt-grey-shade1 RobotoM_14_400 text-end ms-2" }, formattedDate ? formattedDate : "-"),
            React.createElement("span", { className: "RobotoM_14_300 time-text text-end" }, formattedTime ? formattedTime : "-"))) : (React.createElement("span", { className: "RobotoM_14_400 txt-nuvamaBlue ms-3" }, "-"));
    };
    var columnDefs = {
        productName: {
            columnName: "Product Name",
            keysForCustomFunction: [
                "schemeName",
                "category",
                "isinCode",
                "issuer_name",
            ],
            arrows: true,
            type: "string",
            applySorting: true,
            sortKey: "scheme_name",
            tdCustomFunction: defaultSchemeRenderer,
        },
        clientName: {
            type: "string",
            columnClassName: "DMSansMedium_12_500",
            arrowClassName: "justify-content-start",
            columnName: "Client Name",
            sortKey: "client_name",
            arrows: true,
            applySorting: true,
            keysForCustomFunction: ["clientName", "pan"],
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { className: "d-flex flex-column gap-1 client-data-wrapper ", style: { cursor: "pointer" } },
                    React.createElement("span", { className: "DMSanN_14_400 txt-grey-shade1" }, (keys === null || keys === void 0 ? void 0 : keys[0]) ? "".concat(keys[0]) : "-"),
                    React.createElement("span", { className: "txt-grey-shade1 RobotoM_14_400 fw-300" }, (keys === null || keys === void 0 ? void 0 : keys[1]) ? "".concat(keys === null || keys === void 0 ? void 0 : keys[1]) : "-")));
            },
        },
        rmName: {
            columnName: "RM Name",
            keysForCustomFunction: ["rmName", "rmCode"],
            columnClassName: "align-items-start justify-content-start DMSansMedium_12_500 text-start",
            type: "string",
            applySorting: true,
            sortKey: "rm_name",
            arrows: true,
            arrowClassName: "justify-content-start",
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { className: "d-flex flex-column gap-1 client-data-wrapper ", style: { cursor: "pointer" } },
                    React.createElement("span", { className: "DMSanN_14_400 txt-grey-shade1" }, (keys === null || keys === void 0 ? void 0 : keys[0]) ? "".concat(keys[0]) : "-"),
                    React.createElement("span", { className: "txt-grey-shade1 RobotoM_14_400 fw-300" }, (keys === null || keys === void 0 ? void 0 : keys[1]) ? "".concat(keys === null || keys === void 0 ? void 0 : keys[1]) : "-")));
            },
        },
        folioNumber: {
            columnName: "Folio Number",
            key: "folioNumber",
            type: "string",
            applySorting: true,
            sortKey: "folioNumber",
            arrows: true,
            tdCustomFunction: function (key) {
                return (React.createElement("div", { className: "RobotoM_14_400 txt-nuvamaBlue text-end" }, key ? key : "-"));
            },
        },
        date: {
            columnName: "Date",
            key: "orderDate",
            type: "string",
            applySorting: true,
            sortKey: "date",
            arrows: true,
            tdCustomFunction: generateDate,
        },
        amount: {
            columnName: "Amount (₹)",
            key: "amount",
            type: "string",
            applySorting: true,
            sortKey: "amount",
            arrows: true,
            tdCustomFunction: function (key) {
                var _a;
                return (React.createElement("div", { className: "d-flex flex-column gap-1 txt_medium-gray text-end" }, (_a = addCommasWithoutEffectingDecimals(Number(key))) !== null && _a !== void 0 ? _a : "-"));
            },
        },
        redemptionReason: {
            columnName: "Redemption Reason",
            key: "redeemReason",
            type: "string",
            applySorting: true,
            tdCustomFunction: function (key) {
                return (React.createElement("div", { className: "DMSanN_14_400 txt-grey-shade1" }, key ? key : "-"));
            },
        },
    };
    var getCustomColumns = function () {
        switch (String(subCategoryId)) {
            case ESubProductIds.PMS:
            case ESubProductIds.AIF:
                return [
                    columnDefs.productName,
                    columnDefs.clientName,
                    columnDefs.rmName,
                    columnDefs.folioNumber,
                    columnDefs.date,
                    columnDefs.amount,
                    columnDefs.redemptionReason,
                ];
            default:
                return [];
        }
    };
    return useGenerateTableColumns({
        id: id,
        checked: checked,
        handleCheck: handleCheck,
        handleSelectAll: handleSelectAll,
        customColumns: getCustomColumns(),
        data: data,
    });
};
export default generateTableColumns;
